<template>
  <v-container>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.push(`/equipment/${equipmentProfile.id}/inspections`)"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("newInspection.buttons.backbtn") }}</span>
    </v-tooltip>
    <base-material-card
      icon="mdi-clipboard-text-outline"
      color="primary"
      inline
      v-if="equipmentProfile"
      class="mt-12 px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="title text-no-wrap font-weight-bold">
          {{ $t("inspectionProfile.newInspection") }}
          <span v-if="$vuetify.breakpoint.mdAndUp">-</span> <br v-else />
          {{ equipmentProfile.equipTag }}
        </div>
      </template>

      <v-card-text v-if="grupos">
        <validation-observer v-slot="{ handleSubmit }">
          <form
            @submit.prevent="
              handleSubmit(() => {
                modalAfter = true;
              })
            "
          >
            <v-card elevation="0" v-for="(grupo, index) in grupos" :key="index">
              <v-card-title>
                <v-chip
                  color="primary"
                  label=""
                  :x-large="$vuetify.breakpoint.mdAndUp"
                  >{{ $t(`groups.${grupo.name}`) }}</v-chip
                ></v-card-title
              >
              <v-row class="mx-auto" justify="space-around">
                <v-col
                  cols="12"
                  md="6"
                  v-for="(variable, subindex) in grupo.variables"
                  :key="subindex"
                >
                  <validation-provider
                    v-if="variable.type === 'flameColor'"
                    rules="required"
                    :name="`${variable.code}`"
                  >
                    <v-row class="mx-auto" justify="space-around">
                      <v-select
                        v-model="colorSelected"
                        :items="[
                          { name: $t('flame.blue'), value: 3 },
                          { name: $t('flame.yellow'), value: 2 },
                          { name: $t('flame.orange'), value: 1 },
                          { name: $t('flame.red'), value: 0 }
                        ]"
                        label="Color"
                        item-text="name"
                        item-value="value"
                        outlined
                        value="0"
                        dense
                      ></v-select>
                    </v-row>
                  </validation-provider>
                  <validation-provider
                    v-else-if="variable.type === 'steps'"
                    rules="required"
                    :name="`${variable.code}`"
                  >
                    <v-row class="mx-auto" justify="space-around">
                      <v-select
                        v-model="variable.value"
                        :label="$t(`variables.${variable.code}`)"
                        :items="variable.values"
                        item-text="name"
                        item-value="value"
                        outlined
                        required
                        value="0"
                        :rules="[
                          v =>
                            !!v ||
                            `${$t(`variables.${variable.code}`)} is required`
                        ]"
                        return-object
                        dense
                      ></v-select>
                    </v-row>
                  </validation-provider>
                  <validation-provider
                    v-else-if="variable.type === 'flameStability'"
                    rules="required"
                    :name="`${variable.code}`"
                  >
                    <v-row class="mx-auto" justify="space-around">
                      <v-select
                        v-model="stabilitySelected"
                        :items="[
                          { name: $t('flame.focused'), value: 2 },
                          { name: $t('flame.semiFocused'), value: 1 },
                          { name: $t('flame.highDispersion'), value: 0 }
                        ]"
                        value="0"
                        item-text="name"
                        item-value="value"
                        label="Stability"
                        outlined
                        dense
                      ></v-select>
                    </v-row>
                  </validation-provider>
                  <validation-provider
                    v-else-if="variable.type === 'deathLine'"
                    rules="required"
                    :name="`${variable.code}`"
                  >
                    <v-row class="mx-auto" justify="space-around">
                      <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="date"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="variable.value"
                            :label="$t(`variables.${variable.code}`)"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="date" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal = false">
                            {{ $t("newInspection.buttons.cancel") }}
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              modal = false;
                              variable.value = date;
                            "
                          >
                            {{ $t("newInspection.buttons.ok") }}
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-row>
                  </validation-provider>

                  <validation-provider
                    v-else
                    v-slot="{ errors }"
                    rules="required"
                    :name="$t(`variables.${variable.code}`)"
                  >
                    <v-text-field
                      v-if="
                        inspection &&
                          inspection.data &&
                          inspection.data.length > 0
                      "
                      v-model.number="
                        inspection.data[index].variables[subindex].value
                      "
                      :type="'number'"
                      step=".01"
                      :error-messages="errors"
                      color="gray"
                      :label="
                        variablesTags && variablesTags.has(variable.code)
                          ? `${variablesTags.get(variable.code)} - ${$t(
                              `variables.${variable.code}`
                            )}`
                          : $t(`variables.${variable.code}`)
                      "
                      :hint="unit(variable.type) | capitalize"
                      persistent-hint=""
                      validate-on-blur
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-divider class="my-12"></v-divider>
            </v-card>

            <v-textarea
              v-model="inspection.details"
              row-height="4"
              label="Observaciones"
              filled
              hint="Agrega comentarios y observaciones referentes a la inspeccion"
              persistent-hint
            ></v-textarea>

            <v-card-actions class="mt-12">
              <v-spacer></v-spacer
              ><v-btn
                width="250"
                :x-large="$vuetify.breakpoint.mdAndUp"
                primary
                type="submit"
                rounded
                color="primary"
                >{{ $t("ticket.submit") }}</v-btn
              >
              <v-spacer></v-spacer
            ></v-card-actions>

            <v-dialog persistent max-width="350px" v-model="modalAfter">
              <v-card>
                <v-container>
                  <v-row justify="center">
                    <v-col cols="12">
                      <p>{{ $t("newInspection.messages.addTask") }}</p>
                      <v-btn
                        color="primary"
                        block
                        class="my-2 mx-0"
                        @click="modalTask = true"
                      >
                        {{ $t("newInspection.buttons.yes") }}
                      </v-btn>
                      <v-btn
                        color="primary"
                        block
                        class="my-2 mx-0"
                        @click="validateForm"
                      >
                        {{ $t("newInspection.buttons.no") }}
                      </v-btn>
                      <v-btn
                        color="primary"
                        block
                        class="my-2 mx-0"
                        @click="modalAfter = false"
                      >
                        {{ $t("newInspection.buttons.cancel") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-dialog>

            <v-dialog hide-overlay persistent v-model="modalTask">
              <modal-new-task
                :user="user"
                :equipmentProfile="equipmentProfile"
                @cancelTask="modalTask = false"
                @createInspectionAfterTask="validateForm"
              ></modal-new-task>
            </v-dialog>
          </form>
        </validation-observer>
      </v-card-text>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { unitDefault, unitTypes } from "@/settings/unitTypes";
import { db } from "@/plugins/db.js";
import writeValues from "@/mixins/writeValues";
import _ from "lodash";
export default {
  name: "NewInspections",
  components: {
    modalNewTask: () => import("./ModalNewTask")
  },
  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapState("auth", ["user"]),
    ...mapGetters("auth", ["isMetric", "isMetax"]),
    ...mapState("inspections", ["inspections"]),
    grupos() {
      return _.chain(this.equipmentProfile?.variables)
        .groupBy("groups")
        .map((value, key) => ({ name: key, variables: value }))
        .value();
    },
    variablesTags() {
      let tags = new Map();
      if (this.equipmentProfile?.variables?.length > 0) {
        this.equipmentProfile.variables.forEach(variable => {
          if (variable.tagName) tags.set(variable.code, variable.tagName);
        });
      }

      return tags;
    }
  },
  mixins: [writeValues],
  data: () => ({
    inspection: {},
    colorSelected: 1,
    stabilitySelected: 1,
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    modalAfter: false,
    modalTask: false
  }),
  methods: {
    alert(str) {
      alert(str);
    },
    saveDate(date) {
      this.date = new Date(date).toISOString().substr(0, 10);
      this.modal = false;
    },
    transformValue(variable) {
      // transforma la variable si no es metrico a metrico.
      if (this.isMetric) {
        return parseFloat(variable?.value);
      } else {
        let unit = this.unit(variable?.type);
        return parseFloat(this.saveUnit(variable?.value, variable?.type, unit));
      }
    },
    unit(item) {
      // Selecciona el Unit por defecto segun el perfil del usuario
      return this.isMetric
        ? unitDefault[item].metric
        : unitDefault[item].imperial;
    },
    timeAgo(time) {
      const timeObject = [
        ["year", 31536000],
        ["month", 2592000],
        ["day", 86400],
        ["minute", 60],
        ["second", 1]
      ];

      const lang = this.user.language ? this.user.language : "en";
      const rtf = new Intl.RelativeTimeFormat(lang);

      const seconds = time / 1000;
      let timeago;

      for (const [unit, value] of timeObject) {
        if (seconds > value || unit === "seconds") {
          timeago = -Math.floor(parseFloat(seconds / +value));
          return `${rtf.format(timeago, unit)}`;
        }
      }
    },
    alarmZone(variable) {
      if (variable.type === unitTypes.deathLine) {
        let actualTime = new Date() - new Date(variable.value);
        if (actualTime > variable.values[3] * 1000) {
          return {
            status: true,
            code: variable.code,
            value: this.timeAgo(actualTime),
            unit: variable.unit,
            type: variable.type
          };
        } else {
          return { status: false, code: null };
        }
      }
      // Compara si esta en la banda roja de los rangos
      if (
        variable?.value > variable?.values[3] ||
        variable?.value < variable?.values[0]
      ) {
        return {
          status: true,
          code: variable.code,
          value: variable.value,
          unit: variable.unit,
          type: variable.type
        };
      } else {
        return { status: false, code: null };
      }
    },
    smoothZone(variable) {
      if (variable.type === unitTypes.deathLine) {
        let actualTime = new Date() - new Date(variable.value);
        if (actualTime <= variable.values[2] * 1000) {
          return {
            status: true,
            code: variable.code,
            value: this.timeAgo(actualTime),
            unit: variable.unit,
            type: variable.type
          };
        } else {
          return { status: false, code: null };
        }
      }
      // Compara si esta en la banda verde de los rangos
      if (
        variable?.values[1] <= variable?.value &&
        variable?.value <= variable?.values[2]
      ) {
        return {
          status: true,
          code: variable.code,
          value: variable.value,
          unit: variable.unit,
          type: variable.type
        };
      } else {
        return { status: false, code: null };
      }
    },
    warningZone(variable) {
      if (variable.type === unitTypes.deathLine) {
        let actualTime = new Date() - new Date(variable.value);
        if (
          actualTime <= variable.values[3] * 1000 &&
          actualTime > variable.values[2] * 1000
        ) {
          return {
            status: true,
            code: variable.code,
            value: this.timeAgo(actualTime),
            unit: variable.unit,
            type: variable.type
          };
        } else {
          return { status: false, code: null };
        }
      }
      // Compara si esta en la banda amarilla de los rangos
      if (
        (variable?.values[2] < variable?.value &&
          variable?.value <= variable?.values[3]) ||
        (variable?.values[0] <= variable?.value &&
          variable?.value < variable?.values[1])
      ) {
        return {
          status: true,
          code: variable.code,
          value: variable.value,
          unit: variable.unit,
          type: variable.type
        };
      } else {
        return { status: false, code: null };
      }
    },
    resumeInspection(inspection) {
      let data = _.chain(inspection)
        .map(d => d.variables)
        .flatten()
        .value();
      let alarmZone = {
        count: _.chain(data)
          .filter({ alarmZone: { status: true } })
          .size()
          .value(),
        codes: _.chain(data)
          .filter({ alarmZone: { status: true } })
          .map(v => {
            let variable = {};
            variable.groups = v.groups;
            variable.code = v.code;
            variable.unit = v.unit;
            variable.value = v.value;
            variable.type = v.type;
            return variable;
          })
          .value()
      };
      let warningZone = {
        count: _.chain(data)
          .filter({ warningZone: { status: true } })
          .size()
          .value(),
        codes: _.chain(data)
          .filter({ warningZone: { status: true } })
          .map(v => {
            let variable = {};
            variable.groups = v.groups;
            variable.code = v.code;
            variable.unit = v.unit;
            variable.value = v.value;
            variable.type = v.type;
            return variable;
          })
          .value()
      };
      let smoothZone = {
        count: _.chain(data)
          .filter({ smoothZone: { status: true } })
          .size()
          .value(),
        codes: _.chain(data)
          .filter({ smoothZone: { status: true } })
          .map(v => {
            let variable = {};
            variable.groups = v.groups;
            variable.code = v.code;
            variable.unit = v.unit;
            variable.value = v.value;
            variable.type = v.type;
            return variable;
          })
          .value()
      };
      let resume = {
        alarmZone: alarmZone,
        smoothZone: smoothZone,
        warningZone: warningZone
      };

      if (alarmZone.count > 0) {
        resume.status = {
          name: "Alarm ",
          color: "#B81D13",
          value: 3
        };
      } else if (warningZone.count > 0) {
        resume.status = {
          name: "Warning ",
          color: "#EFB700",
          value: 2
        };
      } else {
        resume.status = {
          name: "Smooth ",
          color: "#008450",
          value: 1
        };
      }

      return resume;
    },
    async validateForm(withTask = false, taskId = null) {
      let res = false;

      if (!withTask) {
        res = await this.$dialog.confirm({
          text: this.$t("dashboard.canYouConfirm"),
          title: this.$t("dashboard.checkFields")
        });
      }
      if (res == true || withTask) {
        let dis = this;
        const loading = dis.$vs.loading({
          background: "#730D0B",
          color: "rgb(255, 255, 255)",
          opacity: 1,
          type: "square"
        });
        dis.inspection?.data?.forEach(grupo => {
          switch (grupo.name) {
            case "flame":
              grupo?.variables?.forEach(variable => {
                variable.value = variable.alarmZone = dis.alarmZone(variable);
                variable.warningZone = dis.warningZone(variable);
                variable.smoothZone = dis.smoothZone(variable);
              });
              break;
            case "steps":
              break;
            default:
              grupo?.variables?.forEach(variable => {
                if (variable.type === unitTypes.deathLine) {
                  variable.alarmZone = dis.alarmZone(variable);
                  variable.warningZone = dis.warningZone(variable);
                  variable.smoothZone = dis.smoothZone(variable);
                } else {
                  variable.value = dis.transformValue(variable);
                  variable.alarmZone = dis.alarmZone(variable);
                  variable.warningZone = dis.warningZone(variable);
                  variable.smoothZone = dis.smoothZone(variable);
                }
              });
              break;
          }
        });
        dis.inspection.performedBy = dis.isMetax ? "METAX" : "Customer";
        dis.inspection.dateCreated = new Date();
        dis.inspection.createdBy = dis.user.email;
        dis.inspection.disabled = false;
        dis.inspection.equipmentProfile = db
          .collection("equipments")
          .doc(dis.equipmentProfile.id);
        dis.inspection.resume = dis.resumeInspection(dis.inspection.data);
        dis.inspection.resume.dateCreated = new Date();
        let payload = {
          db: "inspections",
          data: dis.inspection
        };
        let newPayload = {
          db: "equipments",
          data: { lastInspection: dis.inspection.resume },
          doc: dis.equipmentProfile.id
        };

        try {
          if (window.navigator.onLine) {
            let responseUid = await dis.$store.dispatch("addDocument", payload);
            let taskPayload = {
              db: "calendar",
              data: { inspectionId: responseUid },
              doc: taskId ? taskId : null
            };

            if (taskId)
              await dis.$store.dispatch("updateDocument", taskPayload);

            await dis.$store.dispatch("updateDocument", newPayload);
            loading.close();
            this.$router.push("/inspections/" + responseUid);
          } else {
            dis.$store.dispatch("addDocument", payload);
            dis.$store.dispatch("updateDocument", newPayload);
            loading.close();
            this.$dialog.notify.warning(
              "You are offline, therefore your inspection will be sent to the database when you regain the connection. Redirecting to Asset Profile..",
              {
                position: "top-right",
                timeout: 5000
              }
            );
            setTimeout(() => {
              this.$router.push("/equipment/" + dis.equipmentProfile.id);
            }, 4000);
          }
        } catch (error) {
          loading.close();
          console.error(error);
          this.$dialog.notify.error(error, {
            position: "top-right",
            timeout: 5000
          });
        }
      }
    }
  },
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });

    await this.$store.dispatch(
      "equipments/bindAnEquipment",
      this.$route.params.equipId
    );
    const lastInspectionData =
      this.inspections[this.inspections?.length - 1]?.data || [];

    let variables = [];
    lastInspectionData.map(obj => {
      obj?.variables?.map(v => {
        variables.push(v);
      });
    });
    variables = variables.filter(elem => elem.type === unitTypes.deathLine);
    let dis = this;
    this.inspection.data = this.grupos?.map(function(grupos) {
      let gruposDone = {};
      gruposDone.name = grupos.name;
      gruposDone.variables = grupos?.variables?.map(variable => {
        if (variable.type === unitTypes.deathLine) {
          let thisVarLastInfo = variables.find(
            elem => elem.code === variable.code
          );
          if (thisVarLastInfo && thisVarLastInfo.value !== 0) {
            variable.value = new Date(thisVarLastInfo.value)
              .toISOString()
              .substring(0, 10);
            dis.date = new Date(thisVarLastInfo.value)
              .toISOString()
              .substring(0, 10);
          } else {
            variable.value = new Date().toISOString().substr(0, 10);
            dis.date = new Date().toISOString().substr(0, 10);
          }
        } else if (variable.type === "steps") {
          variable.value = {};
        } else {
          variable.value = 0;
        }
        return variable;
      });
      return gruposDone;
    });
    loading.close();
  }
};
</script>
